import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { SuburbanBuildersProjectsBanner } from 'shared/components/SuburbanBuildersProjectsBanner';
import { selectIsBuildersProjectsBannedEnabled } from 'shared/selectors/suburban';

export const SuburbanBuildersProjectsBannerContainer: React.FC = () => {
  const showBanner = useSelector(selectIsBuildersProjectsBannedEnabled);

  if (!showBanner) {
    return null;
  }

  return (
    <CardSectionNew>
      <SuburbanBuildersProjectsBanner />
    </CardSectionNew>
  );
};
